import { faEdit, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "formik";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { Button, InputGroup } from "react-bootstrap";
import { useDeepEffect } from "../../../abstracts";
import {
  FeeApplicableToAddedPlansCard,
  FeeApplicableToFilterCard,
  FeeApplicableToPlanInfoCard,
  LoaderWrapper,
  SliderPanel,
  WarningModal,
} from "../../../components";
import { getPlanListBasedOnFilter } from "../../../services";
import { getPlanGroupsForFee } from "../../../services/Fee";
import AddPlanButton from "../../Mapper/LoadDefHomeContainer/AddPlanButton";
import SearchBar from "../../Mapper/LoadDefHomeContainer/SearchBar";
import PlanSliderPanelPopUp from "../../../components/PlanSliderPanelPopUp/PlanSliderPanelPopUp";

const FeesApplicableToAddPlanGroups = (props) => {
  const {
    setSavePlanGroup,
    savePlanGroup,
    saveexcludedPlans,
    setSaveExcludedPlans,
    errorPlanGroups,
    investmentInformation,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [planGroupsResponse, setPlanGroupsResponse] = useState([]);
  const [addedPlanGroups, setAddedPlanGroups] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [planModalVisible, setPlanModalVisible] = useState(false);
  const [allPlans, setAllPlans] = useState([]);
  const [plans, setPlans] = useState([]);
  const [addedPlans, setAddedPlans] = useState([]);
  const [addedPlansFilter, setAddedPlansFilter] = useState([]);
  const [planListFilter, setPlanListFilter] = useState([]);
  const [searchAddedPlans, setSearchAddedPlans] = useState("");
  const [searchPlanList, setSearchPlanList] = useState("");
  const [searchPlanGroupList, setSearchPlanGroupList] = useState("");
  const [searchListFilter, setSearchListFilter] = useState("");
  const [displayPlansTotal, setdisplayPlansTotal] = useState("");
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [error, setError] = useState("");
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [searchedPlan, setSearchedPlan] = useState("");
  const [plansTotalFilter, setPlansTotalFilter] = useState([]);

  const onViewButtonClick = () => {
    setModalOpen(true);
  };

  useDeepEffect(() => {
    getPlanGroupsForFee(investmentInformation?.id).then((response) => {
      let list = response?.map((item) => {
        return {
          planGroupId: item.id,
          name: item.name,
          count: item.count,
          description: item.description,
        };
      });
      setPlanGroupsResponse(list);
      setSearchPlanGroupList(list);
      if (!isEmpty(savePlanGroup)) {
        let plans = [];
        savePlanGroup.map((plan) => {
          list?.map((item) => {
            if (item.planGroupId == plan.planGroupId) {
              plans = [
                ...plans,
                {
                  ...plan,
                  planGroupId: item.planGroupId,
                  planStatus: item.planStatus,
                },
              ];
            }
          });
        });
        setAddedPlanGroups(plans);
        setSavePlanGroup(plans);
      }
    });
  }, []);

  useDeepEffect(() => {
    if (!isEmpty(searchListFilter)) {
      setPlanGroupsResponse(
        planGroupsResponse.filter((team) => {
          return team.name
            .toLowerCase()
            .includes(searchListFilter.toLowerCase());
        })
      );
    } else if (!isEmpty(searchPlanGroupList)) {
      setPlanGroupsResponse(searchPlanGroupList);
    }
  }, [searchListFilter]);

  useDeepEffect(() => {
    if (!isEmpty(addedPlanGroups)) {
      let x = addedPlanGroups.map((_) => _.planGroupId);
      getPlanListBasedOnFilter({
        planType: [],
        statusType: [],
        advisor: [],
        clearingPartner: [],
        planGroup: !isEmpty(x) ? x : [],
        investment: investmentInformation?.id,
      }).then((response) => {
        !isEmpty(addedPlans)
          ? response.filter(
              (plan) =>
                !addedPlans.map((item) => item.planId).includes(plan.planId)
            )
          : setPlanListFilter(response);
        setPlanListFilter(response);
        setAllPlans(response);
      });
    }
  }, [addedPlanGroups]);

  useDeepEffect(() => {
    if (!isEmpty(saveexcludedPlans)) {
      let plans = [];
      saveexcludedPlans.map((plan) => {
        allPlans.map((item) => {
          if (item.planId == plan.planId) {
            plans = [
              ...plans,
              {
                ...plan,
                planStatus: item.planStatus,
                rkPlanNumber: item.rkPlanNumber,
                planName: item.planName,
                planType: item.planType,
              },
            ];
          }
        });
      });
      setAddedPlans(plans);
      setAddedPlansFilter(plans);
      let x = allPlans.filter(
        (plan) =>
          !saveexcludedPlans.map((item) => item.planId).includes(plan.planId)
      );
      setdisplayPlansTotal(x);
    }
  }, [saveexcludedPlans, allPlans]);

  useDeepEffect(() => {
    let temp = [];
    if (!isEmpty(addedPlans)) {
      temp = planListFilter.filter(
        (plan) => !addedPlans.map((item) => item.planId).includes(plan.planId)
      );
    } else {
      temp = allPlans;
    }
    setPlans(temp);
    setPlanListFilter(temp);
    setFilteredPlans(temp);
    setdisplayPlansTotal(temp);
  }, [addedPlans, allPlans]);

  const onExcludedPlansCancel = () => {
    let temp;
    if (!isEmpty(saveexcludedPlans)) {
      setAddedPlans(saveexcludedPlans);
      setAddedPlansFilter(saveexcludedPlans);
      temp = allPlans.filter(
        (plan) =>
          !saveexcludedPlans.map((item) => item.planId).includes(plan.planId)
      );
      let plans = [];
      saveexcludedPlans.map((plan) => {
        allPlans.map((item) => {
          if (item.planId == plan.planId) {
            plans = [
              ...plans,
              {
                ...plan,
                planStatus: item.planStatus,
                rkPlanNumber: item.rkPlanNumber,
                planName: item.planName,
                planType: item.planType,
              },
            ];
          }
        });
      });
      setSaveExcludedPlans(plans);
    } else {
      temp = allPlans;
      setAddedPlans([]);
      setAddedPlansFilter([]);
    }
    setPlans(temp);
    setPlanListFilter(temp);
    setFilteredPlans(temp);
    setSearchAddedPlans("");
    setSearchPlanList("");
    setPlanModalVisible(false);
  };

  const onExcludedPlansSubmit = (plans) => {
    let temp = allPlans.filter(
      (plan) => !plans.map((item) => item.planId).includes(plan.planId)
    );
    setPlanListFilter(temp);
    setFilteredPlans(temp);
    setSaveExcludedPlans(plans);
    setAddedPlansFilter(plans);
    setSearchAddedPlans("");
    setSearchPlanList("");
    setPlanModalVisible(false);
    let x = allPlans.filter(
      (plan) => !plans.map((item) => item.planId).includes(plan.planId)
    );
    setdisplayPlansTotal(x);
  };

  const addPlanGroups = (inv) => {
    setAddedPlanGroups((e) => [...e, inv]);
  };

  const removePlanGroup = (i) => {
    let x = addedPlanGroups.filter(
      (plan) => i.planGroupId !== plan.planGroupId
    );
    setAddedPlanGroups(x);
  };

  const onSubmit = () => {
    if (isEmpty(addedPlanGroups)) {
      setError("Select a plan group to proceed");
    } else {
      setError("");
      setModalOpen(false);
      setSavePlanGroup(addedPlanGroups);
      setSearchListFilter([]);
      if (isEmpty(addedPlanGroups)) {
        setAddedPlans([]);
        setAllPlans([]);
        setSaveExcludedPlans([]);
        setdisplayPlansTotal([]);
        setAddedPlansFilter([]);
      } else {
        let y = addedPlans.filter((plan) =>
          allPlans.map((item) => item.planId == plan.planId)
        );
        setSaveExcludedPlans(y);
        let x = allPlans.filter(
          (plan) =>
            !saveexcludedPlans.map((item) => item.planId).includes(plan.planId)
        );
        setdisplayPlansTotal(x);
      }
    }
  };

  const onCancel = () => {
    setSearchListFilter([]);
    setError("");
    if (addedPlanGroups.length !== savePlanGroup.length) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };

  const modalOnCancel = () => {
    if (addedPlanGroups !== savePlanGroup) {
      setAddedPlanGroups(savePlanGroup);
    }
    setModalOpen(false);
    setModalVisible(false);
  };

  const onDeleteClick = () => {
    setSaveExcludedPlans([]);
    setAddedPlanGroups([]);
    setAddedPlansFilter([]);
    setSavePlanGroup([]);
    setdisplayPlansTotal([]);
    setAddedPlans([]);
    setAllPlans([]);
  };

  // filtering
  useDeepEffect(() => {
    setPlansTotalFilter(planListFilter);
  }, [planListFilter]);

  useDeepEffect(() => {
    setPlansTotalFilter(
      planListFilter.filter((team) => {
        return (
          team.planName.toLowerCase().includes(searchedPlan.toLowerCase()) ||
          team.rkPlanNumber.toLowerCase().includes(searchedPlan.toLowerCase())
        );
      })
    );
  }, [searchedPlan]);

  return (
    <div>
      <PlanSliderPanelPopUp
        isSliderOpen={isSliderOpen}
        savedPlans={planListFilter}
        setSliderOpen={setSliderOpen}
        setSearchSavedPlans={setSearchedPlan}
        savedPlansFilter={plansTotalFilter}
        header="Plans added to the fee"
        isMapper={false}
      />
      <SliderPanel isOpen={isModalOpen} size="60" showCancel={false}>
        <div className="fee-PlanGroup">
          <div className="d-flex justify-content-between">
            <div className="planGroupTitle pr-5">Plan Group Information</div>
            <div className="pl-5">
              <Button
                variant="secondary"
                onClick={() => {
                  onCancel();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  onSubmit();
                }}
                className="ml-4"
              >
                Save
              </Button>
            </div>
          </div>
          <div className="text-groups">
            {planGroupsResponse.length} plan groups
          </div>
          <div className="search-planGroup pr-5">
            <div className="text-groups"> Search</div>
            <Form>
              <div className="flex-search mb-3rem">
                <InputGroup>
                  <InputGroup.Prepend>
                    <div className="searchIconPostion">
                      <i class="fal fa-search" aria-hidden="true"></i>
                    </div>
                  </InputGroup.Prepend>

                  <SearchBar
                    size="md"
                    type="search"
                    placeholder="Search"
                    className="padding-Search"
                    onChange={(e) => setSearchListFilter(e.target.value)}
                  />
                </InputGroup>
              </div>
            </Form>
          </div>
          <div className="red-small mb-15"> {error} </div>
          <div className="plangroup-card">
            <div className="d-flex text-groups mb-20">
              <div className="plangroup-name-header">
                Name <FontAwesomeIcon icon={faSort} />
              </div>
              <div className="plangroup-description-header">
                Description <FontAwesomeIcon icon={faSort} />
              </div>
              <div className="plangroup-planCount-header">
                No of Plans <FontAwesomeIcon icon={faSort} />
              </div>
              <div>
                Action <FontAwesomeIcon icon={faSort} />
              </div>
            </div>
            {!isEmpty(planGroupsResponse) ? (
              planGroupsResponse?.map((e, i) => {
                return (
                  <div className="d-flex justify-content-between">
                    {[...addedPlanGroups]?.find(
                      (y) => y.planGroupId === e.planGroupId
                    ) ? (
                      <div className="fee-planGroup-card d-flex justify-content-between">
                        <p className="font-plangroup plangroup-name">
                          {e.name}
                        </p>
                        <p className="font-plangroup plangroup-description">
                          {e.description}
                        </p>
                        <p className="font-plangroup plangroup-planCount">
                          {e.count}
                        </p>
                        <div onClick={() => removePlanGroup(e)}>
                          <Button variant="secondary">Remove</Button>
                        </div>
                      </div>
                    ) : (
                      <div className="fee-planGroup-card">
                        <p className="font-plangroup plangroup-name">
                          {e.name}
                        </p>
                        <p className="font-plangroup plangroup-description">
                          {e.description}
                        </p>
                        <p className="font-plangroup plangroup-planCount">
                          {e.count}
                        </p>
                        <div onClick={() => addPlanGroups(e)}>
                          <Button variant="secondary">Add</Button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="p-2 fw-600">No Result found</div>
            )}
          </div>
        </div>
      </SliderPanel>

      <SliderPanel isOpen={planModalVisible} size="80" showCancel={false}>
        <div className="w-100 h-100 planSliderContainer">
          <div className="d-flex justify-content-between">
            <div className="planGroupTitle pr-5 mt-20">
              Excluded Plan Information
            </div>
            <div className="pl-5 mt-20">
              <Button
                variant="secondary"
                onClick={() => {
                  onExcludedPlansCancel();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  onExcludedPlansSubmit(addedPlans);
                }}
                className="ml-4"
              >
                Save
              </Button>
            </div>
          </div>
          <div className="addFeePlansContent">
            <div className="leftcol-fees">
              <FeeApplicableToFilterCard
                setPlanListFilter={setPlanListFilter}
                setFilteredPlans={setFilteredPlans}
                addedPlans={addedPlans}
                addedPlanGroups={addedPlanGroups}
                investmentInformation={investmentInformation}
              />
              <FeeApplicableToPlanInfoCard
                planListFilter={planListFilter}
                setPlanListFilter={setPlanListFilter}
                plans={plans}
                setAddedPlans={setAddedPlans}
                addedPlans={addedPlans}
                setAddedPlansFilter={setAddedPlansFilter}
                setPlans={setPlans}
                addedPlansFilter={addedPlansFilter}
                searchAddedPlans={searchAddedPlans}
                searchPlanList={searchPlanList}
                setSearchPlanList={setSearchPlanList}
                filteredPlans={filteredPlans}
                setFilteredPlans={setFilteredPlans}
                isExclude={true}
              />
            </div>
            <FeeApplicableToAddedPlansCard
              setAddedPlansFilter={setAddedPlansFilter}
              searchAddedPlans={searchAddedPlans}
              addedPlans={addedPlans}
              setSearchAddedPlans={setSearchAddedPlans}
              setPlans={setPlans}
              addedPlansFilter={addedPlansFilter}
              plans={plans}
              setPlanListFilter={setPlanListFilter}
              planListFilter={planListFilter}
              setAddedPlans={setAddedPlans}
              searchPlanList={searchPlanList}
              setFilteredPlans={setFilteredPlans}
              isExclude={true}
            />
          </div>
        </div>
      </SliderPanel>

      {isEmpty(savePlanGroup) ? (
        <>
          <div className="add-module-plan align-items-center justify-content-start bg-white add-items mb-20">
            <div className="p-5">
              <h5 className="mb-3 fee-plan-font">No plan group(s) added</h5>
              <AddPlanButton
                className="AddPlan"
                buttonLabel="Add Plan Group(s)"
                onPrimaryClick={onViewButtonClick}
              />
            </div>
          </div>
          <p className="error-message-deferral">{errorPlanGroups}</p>
        </>
      ) : (
        <div className="addedPlanGroups-Card mb-20">
          <div className="d-flex addedPlans-card-font">
            <div className="col1-width"> Plan Group(s) added</div>
            <div className="col2-width"> Plan(s) added</div>
            <div className="col3-width"> Excluded Plan(s)</div>
          </div>
          <div className="d-flex">
            <div className="blackBold col1-width mt-15 addedPlans-card-font1">
              {savePlanGroup.length}
            </div>
            <div
              className="col2-width mt-15 addedPlans-card-font1"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSliderOpen(!isSliderOpen);
              }}
            >
              {displayPlansTotal.length}
            </div>
            <div className="col3-width mt-15 addedPlans-card-font1">
              <p
                className="link"
                style={{ cursor: "pointer" }}
                onClick={() => setPlanModalVisible(true)}
              >
                {isEmpty(saveexcludedPlans) ? "+add" : saveexcludedPlans.length}
              </p>
            </div>
            <div
              className="edit-color fee-cursor"
              onClick={() => {
                setModalOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </div>
            <div
              className="trash-color fee-cursor pl-3"
              onClick={() => {
                onDeleteClick();
              }}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </div>
          </div>
        </div>
      )}

      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default FeesApplicableToAddPlanGroups;
